async function getBookingList(companyUuid: string, type: string, page: number, limit: number, sort: string) {
  const response = await fetch(
    process.env.REACT_APP_API_URL +
      `hospitality/get-booking?companyUuid=${companyUuid}&bookingType=${type}&page=${page}&limit=${limit}&sort=${sort}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );

  // Check if the response is successful
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  // Parse the response body to JSON
  return await response.json();
}

export default getBookingList;
